import { render } from "./PreviousFormsTable.vue?vue&type=template&id=2c6249e6&scoped=true"
import script from "./PreviousFormsTable.vue?vue&type=script&lang=js"
export * from "./PreviousFormsTable.vue?vue&type=script&lang=js"

import "./PreviousFormsTable.vue?vue&type=style&index=0&id=2c6249e6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6249e6"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QSpinner,QTable,QTr,QTd,QBadge,QTooltip,QBtn,QMenu,QCard,QCardSection,QCardActions});qInstall(script, 'directives', {ClosePopup});
